import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import { fg } from '@confluence/feature-gating';

import { ContentToolsItemPlaceholder } from './ContentToolsItemPlaceholder.tsx';
import type { DropdownItemProps } from '@atlaskit/dropdown-menu/types';

export const LazyContentToolsItem: LoadableType<
	{
		id?: string | null;
		innerRef?: React.LegacyRef<HTMLElement>;
		label: React.ReactNode;
		onMouseEnter?: React.MouseEventHandler;
		className?: string;
		url?: DropdownItemProps['href'] | null;
		shouldHighlight?: boolean;
		elemBefore?: DropdownItemProps['elemBefore'];
	} & Pick<DropdownItemProps, 'isDisabled' | 'onClick' | 'testId' | 'interactionName'> &
		React.RefAttributes<HTMLElement>
> = LoadableLazy({
	loader: async () =>
		fg('confluence_link_item_append_trace_context')
			? (
					await import(
						/* webpackChunkName: "loadable-ContentToolsItemWithRoutesContext" */ './ContentToolsItemWithRoutesContext.tsx'
					)
				).ContentToolsItemWithRoutesContext
			: (await import(/* webpackChunkName: "loadable-ContentToolsItem" */ './ContentToolsItem.tsx'))
					.ContentToolsItem,
});

export const LazyContentToolsItemWithPlaceholder: LoadableType<
	{
		id?: string | null;
		innerRef?: React.LegacyRef<HTMLElement>;
		label: React.ReactNode;
		onMouseEnter?: React.MouseEventHandler;
		className?: string;
		url?: DropdownItemProps['href'] | null;
		shouldHighlight?: boolean;
		elemBefore?: DropdownItemProps['elemBefore'];
	} & Pick<DropdownItemProps, 'isDisabled' | 'onClick' | 'testId' | 'interactionName'> &
		React.RefAttributes<HTMLElement>
> = LoadableLazy({
	loader: async () =>
		fg('confluence_link_item_append_trace_context')
			? (
					await import(
						/* webpackChunkName: "loadable-ContentToolsItemWithRoutesContext" */ './ContentToolsItemWithRoutesContext.tsx'
					)
				).ContentToolsItemWithRoutesContext
			: (await import(/* webpackChunkName: "loadable-ContentToolsItem" */ './ContentToolsItem.tsx'))
					.ContentToolsItem,
	loading: () => <ContentToolsItemPlaceholder />,
});
